import { IModel, Model } from './model'
import { IUser, User } from './user'
import { IReference } from './reference'
import { IStatement } from './statement'
import { IComment } from './comment'

export interface IConvo extends IModel {
  title: string | null
  body: string | null
  meta: ConvoMeta | null
}

export class Convo extends Model implements IConvo {
  public title: string | null = null
  public body: string | null = null
  public meta: ConvoMeta | null = null
}

export class ConvoMeta {
  public creator: IUser = new User()
  public numLikes: number = 0
  public isAllJybed: boolean = false
  public isLiked: boolean = false
  public isFollowed: boolean = false
  public tags: string[] = []
  public references: IReference[] = []
  public statements: IStatement[] = []
  public comments: IComment[] = []
  public newCommentTitle: string = ''
  public newCommentBody: string = ''
  public newCommentStatements: IStatement[] = []
  public newTag: string = ''
  public newUrl: string = ''
  public newDesc: string = ''
}

export class ConvoForm {
  public id: number|null = null;
  public title: string = ''
  public body: string = ''
  public tag: string = ''
  public tags: string[] = []
  public referenceUrl: string = ''
  public referenceDesc: string = ''
  public references: IReference[] = []
  public statements: IStatement[] = []
}